export const getSelectedFiltersKeys = carFiltersSelected => {
  return Object.keys(carFiltersSelected).filter(
    key => carFiltersSelected[key].length > 0
  )
}
